<template>
  <section
    class="ds-card"
    :class="{ flush }"
  >
    <header
      v-if="title || subtitle || $slots.actions"
      class="ds-card-head"
    >
      <div class="ds-card-head-text">
        <div
          v-if="eyebrow"
          class="ds-card-eyebrow"
        >
          {{ eyebrow }}
        </div>
        <h2
          v-if="title"
          class="ds-card-title"
        >
          {{ title }}
        </h2>
        <p
          v-if="subtitle"
          class="ds-card-sub"
        >
          {{ subtitle }}
        </p>
      </div>
      <div
        v-if="$slots.actions"
        class="ds-card-actions"
      >
        <slot name="actions" />
      </div>
    </header>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'DsCard',
  props: {
    // No title/subtitle/actions = a bare shell around the default slot.
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    eyebrow: {
      type: String,
      default: '',
    },
    // Drops body padding, for content that draws its own edges (e.g. a table).
    flush: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

.ds-card {
  @include ds-card;

  &.flush {
    padding: 0;
    overflow: hidden;

    > .ds-card-head {
      padding: 22px 26px;
      border-bottom: 1px solid $c-border-light;

      &:not(:last-child) {
        margin-bottom: 0;
      }
    }
  }
}

.ds-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  // Header-only cards keep their own padding, so only space it off real content.
  &:not(:last-child) {
    margin-bottom: 20px;
  }
}

.ds-card-head-text {
  min-width: 0;
}

.ds-card-eyebrow {
  @include ds-eyebrow;

  margin-bottom: 5px;
}

.ds-card-title {
  @include ds-title;
}

.ds-card-sub {
  @include ds-subtitle;

  margin-top: 3px;
}

.ds-card-actions {
  flex-shrink: 0;
}
</style>
